export const CLOSE = 'close'
export const LOGIN = 'login'
export const MAX_WIDTH = '564px'
export const CONTINUE = 'Continue'
export const NEVERMIND = 'Nevermind'
export const TITLE_TEXT = 'Are you sure you want to change your citation style?'
export const INFO_TEXT =
  'You will not be able to change your citation style again without subscribing'
